import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "google-map__info-window" }
const _hoisted_2 = { class: "google-map__info-window__image-container" }
const _hoisted_3 = { class: "google-map__info-window__info" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["href"]

import { GoogleMap, Marker, MarkerCluster, InfoWindow } from "vue3-google-map";
import dictionary from "@/i18n/dictionary.json";
import TressResponsivePicture from "@/components/TressResponsivePicture.vue";
import { PropType, computed } from "vue";
import { IResponsiveImagesModel } from "@/models/IResponsiveImagesModel";

type MarkerModel = {
  name: string;
  coordinate: {
    lat: number;
    lng: number;
  };
  squareImage: IResponsiveImagesModel;
  url: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'TressGoogleMap',
  props: {
  center: {
    type: Object,
    required: true,
  },
  markers: {
    type: Object as PropType<MarkerModel[]>,
    required: true,
  },
  zoom: {
    type: Number,
    required: true,
  },
  apiKey: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;



const markersWithCoordinates = computed(() =>
  props.markers.filter((x) => x.coordinate != null && !isNaN(x.coordinate.lat) && !isNaN(x.coordinate.lng))
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(GoogleMap), {
    "api-key": __props.apiKey,
    center: __props.center,
    "disable-default-ui": true,
    draggable: true,
    zoom: __props.zoom,
    "zoom-control": true,
    class: "google-map",
    style: {"width":"100%","height":"100%","position":"relative"}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(MarkerCluster), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(markersWithCoordinates.value, (marker) => {
            return (_openBlock(), _createBlock(_unref(Marker), {
              key: marker.name,
              options: { position: marker.coordinate }
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(InfoWindow), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(TressResponsivePicture, {
                          pictures: marker.squareImage,
                          class: "google-map__info-window__img"
                        }, null, 8, ["pictures"])
                      ]),
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                          class: "google-map__info-window__info__header",
                          innerHTML: marker.name
                        }, null, 8, _hoisted_4),
                        _createElementVNode("a", {
                          href: marker.url,
                          class: "button button--default-denary move-to-top google-map__info-window__link",
                          type: "button"
                        }, _toDisplayString(_ctx.$t(_unref(dictionary).caseOverview.readMore)), 9, _hoisted_5)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["options"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["api-key", "center", "zoom"]))
}
}

})